import React from 'react';
import { Input } from 'lib/releox-react';

export default () => (
  <>
    <Input name="password" type="password" label="Password" />
  </>
);
